import { DataLayerActions, DataLayerActionTypes } from '../actions/data-layer';
import { I18nState, DeviceState, UserState, BooleanString, NonLogged } from '../models/types';
import { environment } from '@env/environment';

export interface State extends I18nState, DeviceState, UserState {
  new_platform: BooleanString.True;
  env_work: string;
  [property: string]: any;
}

export const initialState: State = {
  new_platform: BooleanString.True,
  angular_first_call: BooleanString.False,
  env_work: environment.analytics.envName,
  env_channel: 'desktop',
  responsive: BooleanString.False,
  cust_firstname: '',
  user_id: '',
  user_email: '',
  user_accountLevel: NonLogged.Value,
  user_buyerStatus: NonLogged.Value,
  user_sellerStatus: NonLogged.Value,
  user_seller_rating: NonLogged.Value,
  user_fashion_activist: NonLogged.Value,
  user_category: NonLogged.Value,
  cookie_analytics: 'default_false',
  cookie_customization: 'default_false',
  cookie_media: 'default_false',
  user_iphoneApp: NonLogged.Value,
  user_androidApp: NonLogged.Value,
  user_date_inscription: '',
  user_relativedate: '',
  index_name: '',
  order_products: [],
  order_amount_ati_with_sf: '',
  product_unitprice_ati: '',
  onsite_campaign_id: ''
};

export function reducer(state = initialState, action: DataLayerActions): State {
  switch (action.type) {
    case DataLayerActionTypes.Persist:
      const newState = action.payload || {};
      return {
        ...state,
        ...newState
      };

    default:
      return state;
  }
}
